import { Navigate } from 'react-router';

/** Recording starts from the setup screen (it needs the camera and a saved line first). */
export function StationRecordPage() {
  return <Navigate to="/station/setup" replace />;
}
